import { StarFaceIcon } from './StarFaceIcon';

/**
 * author: Google
 * id 20FBE06D-72C3-4E1C-945D-C7E69DC0736D
 * name star-face
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-face.svg
 * tags
 * - Gaming / RPG 
 */
export const FavoriteFaceIcon = StarFaceIcon;
export default FavoriteFaceIcon